<template>
	<div class="switcher">
		<button
			v-for="entry in languages"
			:key="entry.title"
			@click="changeLocale(entry.language)"
		>
			<flag :iso="entry.flag" :squared="false" />
		</button>
	</div>
</template>

<script>
export default {
	name: 'Switcher',
	methods: {
		changeLocale(locale) {
			if (this.$i18n.locale !== locale) {
				this.$i18n.locale = locale;
			}
		},
	},
	data() {
		return {
			languages: [
				{ flag: 'gb', language: 'en' },
				{ flag: 'no', language: 'no' },
			],
		};
	},
};
</script>

<style lang="scss" scoped>
.switcher {
	button {
		padding: 4px 6px 4px 6px;
		margin-left: 10px;
		cursor: pointer;
	}
}
</style>
